var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Index"},[_c('headNav',{attrs:{"activeNav":'Inicio'}}),_c('Inicio'),_c('footPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }